import React from "react";
import "./Policy.css";

const ConfidentialityPolicy = () => {
  return (
    <div className="policy-page">
      
      {/* HERO */}
      <div className="policy-hero">
        <h1>Confidentiality Policy</h1>
        <p>
          Protecting client information with the highest standards of privacy,
          integrity, and professional responsibility.
        </p>
      </div>

      {/* CONTENT */}
      <div className="policy-content">

        {/* INTRODUCTION */}
        <div className="policy-section">
          <h2>📌 Confidentiality Policy</h2>

          <p>
            At E-Advisors Solution, safeguarding client information is one of
            our highest priorities. We understand the importance of trust in
            professional relationships and are fully committed to protecting
            the confidentiality, integrity, and privacy of all information
            shared with us.
          </p>

          <p>
            All data, documents, and business details provided by our clients
            are handled with strict security standards and ethical
            responsibility.
          </p>
        </div>

        {/* COMMITMENT */}
        <div className="policy-section">
          <h2>🔒 Our Commitment to Privacy</h2>

          <div className="policy-card">
            <h3>We Strictly Maintain Confidentiality By:</h3>

            <ul>
              <li>
                Ensuring that all client information and submitted documents
                remain secure and protected at every stage of service delivery.
              </li>

              <li>
                Sharing information only when required for processing
                services, legal compliance, or submission to authorized
                government departments and regulatory authorities.
              </li>

              <li>
                Implementing internal privacy controls and secure data
                handling practices to prevent unauthorized access, misuse,
                or disclosure.
              </li>
            </ul>
          </div>
        </div>

        {/* WE NEVER */}
        <div className="policy-section">
          <h2>🚫 We Never</h2>

          <div className="policy-card">
            <ul>
              <li>
                Disclose client information, business details, or confidential
                documents to any unauthorized third party.
              </li>

              <li>
                Publish, share, rent, or distribute our client database or
                customer records without prior written consent.
              </li>

              <li>
                Sell, trade, or commercially exploit client information under
                any circumstances.
              </li>
            </ul>
          </div>
        </div>

        {/* DATA PROTECTION */}
        <div className="policy-section">
          <h2>🛡️ Data Protection Assurance</h2>

          <p>
            E-Advisors Solution continuously works toward maintaining
            transparency, professionalism, and data security in all business
            operations.
          </p>

          <p>
            Our confidentiality practices are designed to build long-term
            trust and ensure complete peace of mind for every client
            associated with us.
          </p>

          <div className="highlight-box">
            Your information remains confidential and is handled with the
            highest level of security, professionalism, and ethical
            responsibility.
          </div>
        </div>

        {/* WEBSITE */}
        <div className="website-card">
          <h3>🌐 Official Website</h3>

          <a
            href="https://e-advisorssolution.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://e-advisorssolution.com
          </a>
        </div>

      </div>
    </div>
  );
};

export default ConfidentialityPolicy;